import React from "react";

function NetworkSecurity() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            Network Security Assessment
          </span>
        </div>
        <p>
          Network Security Assessment identifies potential entry portals used by
          cybercriminals as vulnerability points in your network and devices. By
          securing the weak and risky points, we eliminate the opportunities for
          breaching and hacking your data.{" "}
        </p>
        <p>
          {" "}
          Sub-services we offer in Network Security Assessment to give a 360°
          view of the network for securing it are:
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">External Network Penetration Testing</h5>
                <div class="card-text mt-3 mb-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi
                  nostrum ab doloremque magnam harum atque debitis, dolor
                  placeat eaque sed.
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Internal Network Penetration Testing</h5>
                <div class="card-text mt-3 mb-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi
                  nostrum ab doloremque magnam harum atque debitis, dolor
                  placeat eaque sed.
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Wireless Penetration Testing</h5>
                <div class="card-text mt-3 mb-3">
                  Going for a wireless network brings both benefits and risks.
                  Therefore, a wireless network assessment by wireless
                  penetration tests comes in handy. Secure your wireless network
                  now to save yourself from cleaning a big dirty mess by an
                  unwanted guest later as/Rise fearlessly now with wireless
                  penetration test because-
                  <ol className="mt-3">
                    <li>
                      It helps in reckoning the wireless installation and
                      recognizing the chances of risk and leakage.
                    </li>
                    <li>
                      It identifies the bugs, viruses, and legitimate and
                      non-legitimate users with identities.
                    </li>
                    <li>
                      It assists in blocking the hacker and securing your
                      information from being infiltrated in an unauthorized
                      manner.
                    </li>
                    <li>
                      It maximizes the system's performance and efficiency.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">External Network Penetration Testing</h5>
                <div class="card-text mt-3 mb-3">
                  SCADA is the abbreviation of Supervisory Control and Data
                  Acquisition. SCADA Pentesting is an advanced testing technique
                  used in the industrial control system for monitoring and
                  controlling industrial systems, infrastructure, and machinery.{" "}
                  <br />
                  Secure your (need the name or word for the place SCADA pentest
                  is used at/for) now to save yourself from cleaning a big dirty
                  mess by an unwanted guest later as/Rise fearlessly now with
                  SCADA penetration test because:
                  <ol className="mt-3">
                    <li>
                      It notifies us about the threats present/approaching by
                      alarming us beforehand.
                    </li>
                    <li>
                      It automates the control over machinery and industrial
                      systems.
                    </li>
                    <li>
                      It simplifies the information and functionality in the
                      form of reports and graphs.
                    </li>
                    <li>
                      It maintains the operating condition of the system in all
                      situations.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NetworkSecurity;
